/**
 * TELA 06 — FINALIZAÇÃO
 * Dados do cliente, entrega ou retirada, forma de pagamento, resumo e redirecionamento para o WhatsApp.
 */

import { STORE_INFO } from '../data/menuData.js';
import { formatCurrency } from '../utils/formatters.js';
import { buildWhatsAppMessage, generateWhatsAppLink } from '../utils/whatsapp.js';

export function renderCheckoutView(container, store) {
  const items = store.cart;
  if (items.length === 0) {
    store.setView('cart');
    return;
  }

  // Estado local do checkout
  let orderType = 'delivery'; // 'delivery' | 'pickup'
  let paymentMethod = 'pix'; // 'pix' | 'dinheiro' | 'cartao_debito' | 'cartao_credito'

  const subtotal = store.getSubtotal();
  const deliveryFee = store.getDeliveryFee();
  const total = store.getTotal();

  container.innerHTML = `
    <div style="max-width: 880px; margin: 20px auto;">
      <!-- Barra Superior -->
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; padding-bottom: 12px; border-bottom: 1px solid var(--border-subtle);">
        <button id="btn-back-cart" class="btn btn-secondary btn-sm">
          <span>←</span> <span>Voltar ao Carrinho</span>
        </button>
        <h1 style="font-size: 1.3rem; font-weight: 800; color: var(--text-primary);">Finalizar Pedido</h1>
        <span class="badge badge-gold">WhatsApp</span>
      </div>

      <div class="checkout-grid">
        <!-- Coluna Esquerda: Formulário -->
        <div class="custom-panel" style="margin: 0;">
          <h2 style="font-size: 1.15rem; font-weight: 700; margin-bottom: 16px; color: var(--text-primary);">
            1. Como deseja receber?
          </h2>

          <!-- Seletor Entrega / Retirada -->
          <div class="radio-group" id="order-type-group" style="margin-bottom: 20px;">
            <div class="radio-card active" data-type="delivery">
              <span class="radio-indicator"></span>
              <div>
                <strong>🛵 Entrega (Delivery)</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Entregamos no seu endereço</span>
              </div>
            </div>

            <div class="radio-card" data-type="pickup">
              <span class="radio-indicator"></span>
              <div>
                <strong>🛍️ Retirada no Balcão</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Av. Sete de Setembro, 1167</span>
              </div>
            </div>
          </div>

          <h2 style="font-size: 1.15rem; font-weight: 700; margin-bottom: 14px; color: var(--text-primary);">
            2. Seus Dados
          </h2>

          <div class="form-group">
            <label class="form-label" for="customer-name">Seu Nome Completo <span style="color: var(--accent-gold); font-weight: 700;">*</span></label>
            <input type="text" id="customer-name" class="form-control" placeholder="Ex: João da Silva" required />
          </div>

          <div class="form-group">
            <label class="form-label" for="customer-phone">Telefone / WhatsApp (Opcional)</label>
            <input type="tel" id="customer-phone" class="form-control" placeholder="Ex: (32) 99999-9999" />
          </div>

          <!-- Campos de Endereço (condicionais se entrega) -->
          <div id="delivery-fields">
            <div class="form-group">
              <label class="form-label" for="delivery-address">Endereço de Entrega Completo <span style="color: var(--accent-gold); font-weight: 700;">*</span></label>
              <input type="text" id="delivery-address" class="form-control" placeholder="Rua, número, complemento e bairro" />
            </div>

            <div class="form-group">
              <label class="form-label" for="delivery-reference">Ponto de Referência</label>
              <input type="text" id="delivery-reference" class="form-control" placeholder="Ex: Próximo à praça, portão preto..." />
            </div>
          </div>

          <h2 style="font-size: 1.15rem; font-weight: 700; margin: 24px 0 14px 0; color: var(--text-primary);">
            3. Forma de Pagamento
          </h2>

          <div class="radio-group" id="payment-options" style="margin-bottom: 16px;">
            <div class="radio-card active" data-payment="pix">
              <span class="radio-indicator"></span>
              <div>
                <strong>💠 Pix Manual</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Chave enviada na conversa</span>
              </div>
            </div>

            <div class="radio-card" data-payment="dinheiro">
              <span class="radio-indicator"></span>
              <div>
                <strong>💵 Dinheiro</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Pagar na entrega/retirada</span>
              </div>
            </div>

            <div class="radio-card" data-payment="cartao_debito">
              <span class="radio-indicator"></span>
              <div>
                <strong>💳 Cartão (Débito)</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Maquininha na entrega</span>
              </div>
            </div>

            <div class="radio-card" data-payment="cartao_credito">
              <span class="radio-indicator"></span>
              <div>
                <strong>💳 Cartão (Crédito)</strong>
                <span style="font-size: 0.78rem; color: var(--text-muted); display: block;">Maquininha na entrega</span>
              </div>
            </div>
          </div>

          <!-- Campo de Troco se Dinheiro -->
          <div id="cash-change-group" style="display: none; margin-bottom: 16px;">
            <div class="form-group">
              <label class="form-label" for="cash-change-val">Troco para quanto?</label>
              <input type="number" id="cash-change-val" class="form-control" placeholder="Ex: 50 ou 100 (deixe em branco se não precisar)" />
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="general-notes">Observações Gerais do Pedido</label>
            <textarea id="general-notes" class="form-control" rows="2" placeholder="Alguma instrução especial para a entrega ou preparo?"></textarea>
          </div>
        </div>

        <!-- Coluna Direita: Resumo e Envio -->
        <div>
          <div class="cart-summary-box" style="margin: 0; position: sticky; top: 80px;">
            <h3 style="font-size: 1.1rem; font-weight: 700; margin-bottom: 12px; color: var(--text-primary);">
              Resumo do Pedido
            </h3>

            <div style="max-height: 240px; overflow-y: auto; display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px; padding-right: 4px;">
              ${items.map(item => `
                <div style="display: flex; justify-content: space-between; font-size: 0.85rem; padding-bottom: 6px; border-bottom: 1px dashed var(--border-subtle);">
                  <div>
                    <strong>${item.quantity}x ${item.name}</strong>
                    ${item.sizeName ? `<span style="display: block; font-size: 0.75rem; color: var(--text-muted);">${item.sizeName}</span>` : ''}
                    ${item.selectedMeat ? `<span style="display: block; font-size: 0.75rem; color: var(--text-muted);">Carne: ${item.selectedMeat}</span>` : ''}
                  </div>
                  <span style="font-weight: 600; color: var(--accent-gold-light);">
                    ${item.pricePending ? 'A confirmar' : formatCurrency(item.totalPrice)}
                  </span>
                </div>
              `).join('')}
            </div>

            <div class="summary-row">
              <span>Subtotal:</span>
              <strong>${formatCurrency(subtotal)}</strong>
            </div>

            <div class="summary-row">
              <span>Taxa de Entrega:</span>
              <strong style="color: var(--accent-gold-light);">${deliveryFee !== null ? formatCurrency(deliveryFee) : 'A DEFINIR'}</strong>
            </div>

            <div class="summary-row summary-total">
              <span>Total:</span>
              <span>${formatCurrency(total)}</span>
            </div>

            <div style="margin: 16px 0 10px 0; font-size: 0.8rem; color: var(--text-muted); background: rgba(255,255,255,0.03); padding: 10px; border-radius: var(--radius-sm);">
              📱 <strong>Como funciona:</strong> Ao tocar no botão abaixo, seu WhatsApp abrirá com o pedido pré-formatado. Você confere e toca manualmente em <em>Enviar</em>!
            </div>

            <button id="btn-submit-whatsapp" class="btn btn-whatsapp btn-block" style="padding: 16px;">
              <span style="font-size: 1.2rem;">💬</span>
              <span>Finalizar no WhatsApp</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  // Listeners de Tipo de Pedido (Entrega / Retirada)
  const deliveryFields = container.querySelector('#delivery-fields');
  container.querySelectorAll('#order-type-group .radio-card').forEach(card => {
    card.addEventListener('click', () => {
      container.querySelectorAll('#order-type-group .radio-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      orderType = card.getAttribute('data-type');

      if (orderType === 'delivery') {
        deliveryFields.style.display = 'block';
      } else {
        deliveryFields.style.display = 'none';
      }
    });
  });

  // Listeners de Forma de Pagamento
  const cashChangeGroup = container.querySelector('#cash-change-group');
  container.querySelectorAll('#payment-options .radio-card').forEach(card => {
    card.addEventListener('click', () => {
      container.querySelectorAll('#payment-options .radio-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
      paymentMethod = card.getAttribute('data-payment');

      if (paymentMethod === 'dinheiro') {
        cashChangeGroup.style.display = 'block';
      } else {
        cashChangeGroup.style.display = 'none';
      }
    });
  });

  // Voltar ao Carrinho
  container.querySelector('#btn-back-cart')?.addEventListener('click', () => {
    store.setView('cart');
  });

  // Finalizar no WhatsApp
  container.querySelector('#btn-submit-whatsapp')?.addEventListener('click', () => {
    const customerName = container.querySelector('#customer-name')?.value || '';
    const phone = container.querySelector('#customer-phone')?.value || '';
    const address = container.querySelector('#delivery-address')?.value || '';
    const reference = container.querySelector('#delivery-reference')?.value || '';
    const changeFor = container.querySelector('#cash-change-val')?.value || '';
    const generalNotes = container.querySelector('#general-notes')?.value || '';

    // Validações
    if (!customerName.trim()) {
      alert("Por favor, informe seu nome para identificar o pedido.");
      container.querySelector('#customer-name')?.focus();
      return;
    }

    if (orderType === 'delivery' && !address.trim()) {
      alert("Por favor, informe seu endereço completo para a entrega.");
      container.querySelector('#delivery-address')?.focus();
      return;
    }

    const orderData = {
      customerName,
      phone,
      orderType,
      address,
      reference,
      paymentMethod,
      changeFor,
      generalNotes,
      cartItems: items,
      subtotal,
      deliveryFee,
      total
    };

    const message = buildWhatsAppMessage(orderData, STORE_INFO);
    const link = generateWhatsAppLink(STORE_INFO.whatsapp, message);

    // Abre o WhatsApp no navegador/app
    window.open(link, '_blank');
  });
}
